/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ListItemGroup_EmbedNode = {
    readonly " $fragmentRefs": FragmentRefs<"ListItemNode_EmbedNode" | "TypographyNodeName_EmbedNode">;
    readonly " $refType": "ListItemGroup_EmbedNode";
};
export type ListItemGroup_EmbedNode$data = ListItemGroup_EmbedNode;
export type ListItemGroup_EmbedNode$key = {
    readonly " $data"?: ListItemGroup_EmbedNode$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListItemGroup_EmbedNode">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListItemGroup_EmbedNode",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ListItemNode_EmbedNode"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TypographyNodeName_EmbedNode"
        }
      ],
      "type": "Group",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
(node as any).hash = '62e9c1af52ad14af7cd09066b9093aad';
export default node;
